import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: React.ReactElement;
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  side = 'top',
  children
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const positions = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2'
  };

  return (
    <div className="relative inline-block">
      {React.cloneElement(children, {
        onMouseEnter: () => setIsVisible(true),
        onMouseLeave: () => setIsVisible(false),
        onFocus: () => setIsVisible(true),
        onBlur: () => setIsVisible(false),
      })}
      {isVisible && (
        <div
          className={`
            absolute z-50 px-2 py-1
            text-xs text-white
            bg-gray-800 rounded
            whitespace-nowrap
            ${positions[side]}
          `}
          role="tooltip"
        >
          {content}
          <div
            className={`
              absolute w-2 h-2
              bg-gray-800
              transform rotate-45
              ${
                side === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2' :
                side === 'right' ? 'left-[-4px] top-1/2 -translate-y-1/2' :
                side === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2' :
                'right-[-4px] top-1/2 -translate-y-1/2'
              }
            `}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;